import React from "react";

function DigitalWalletIcon({ stroke = "#667085" }) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.25 6.41667H17.4167C18.4292 6.41667 19.25 7.23748 19.25 8.25V16.5C19.25 17.5125 18.4292 18.3333 17.4167 18.3333H4.58333C3.57081 18.3333 2.75 17.5125 2.75 16.5V5.5C2.75 4.48748 3.57081 3.66667 4.58333 3.66667H16.0417"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.125 13.2917C15.6313 13.2917 16.0417 12.8813 16.0417 12.375C16.0417 11.8687 15.6313 11.4583 15.125 11.4583C14.6187 11.4583 14.2083 11.8687 14.2083 12.375C14.2083 12.8813 14.6187 13.2917 15.125 13.2917Z"
        fill={stroke}
      />
      <path
        d="M2.75 7.33333V6.41667C2.75 5.40415 3.57081 4.58333 4.58333 4.58333H15.125"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DigitalWalletIcon;
